export var EndPoints = {
    statistic: {
        kpi: 'statistics/kpi-response-stat',
        kpiRangeDate: 'statistics/kpi-response-stat-range-date',
    },
    departement: {
        create: 'departments',
    },
};
